import React from 'react'

import ButtonContainer from '../../elements/ButtonContainer'

const FormButtonContainer = ({ ...rest }) => <ButtonContainer {...rest} />

export default FormButtonContainer
